import React from "react";
import { BiPhoneCall } from "react-icons/bi";
import { AiOutlineMail } from "react-icons/ai";
import { MdOutlineLocationOn } from "react-icons/md";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";

function TopSocial() {
  return (
    <div className="bg-second text-white">
      <div className="container mx-auto h-12 justify-between items-center flex text-sm sm:my-4 md:my-0">
        <div className="contact flex justify-between md:gap-x-4 md:flex-row md:mx-0  sm:flex-col sm:gap-x-auto sm:text-sm sm:gap-y-2">
          <div className="number flex gap-x-2">
            <BiPhoneCall className="mt-1" />
            <a href="tel:0507648850 ">+994 50 764 88 50</a>
          </div>
          <div className="email flex gap-x-2">
            <AiOutlineMail className="mt-1" />
            <a href="mailto:suleymanismayilov8@gmail.com">
              suleymanismayilov8@gmail.com
            </a>
          </div>
          <div className="location  md:flex sm:hidden gap-x-2">
            <MdOutlineLocationOn className="mt-1" />
            <p>Bakı, Azərbaycan</p>
          </div>
        </div>
        <div className="social md:flex sm:hidden gap-x-5 text-lg">
          <a href="https://www.facebook.com/Zaferoglu-%C4%B0n%C5%9Faat-136901673641060">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/zaferoglu_inshaat/">
            <FaInstagram />
          </a>
          <a href="https://www.linkedin.com/company/zaferoglu-inshaat/">
            <FaLinkedinIn />
          </a>
          <a href="https://wa.me/+994517111111">
            <FaWhatsapp />
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopSocial;
